import React from 'react';

export default function Toast({ message, onClose }) {
  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50">
      <div className="bg-gray-700 border border-gray-600 text-white px-6 py-3 rounded-xl shadow-lg flex items-center gap-3">
        <span>{message}</span>
        <button onClick={onClose} className="text-gray-400 hover:text-white text-lg">✕</button>
      </div>
    </div>
  );
}
